import {ActionTree} from 'vuex'
import {ModerationState} from '@/modules/cms/modules/moderation/store/index'
import {RootState} from '@/store/types'
import {MutationTypes} from '@/modules/cms/modules/moderation/store/mutations'
import * as api from '@/modules/cms/modules/moderation/api'
import ModerationVote from '@/modules/cms/modules/moderation/model/ModerationVote';
import User from '@/modules/user/model/User';

export interface VoteDescriptor {
    contentType: string,
    contentId: number | string
}

/**
 * Acciones del módulo de moderación
 */
const actions: ActionTree<ModerationState, RootState> = {
    /**
     * Carga en el estado una lista de votos de moderación asociados a un tipo de contenido
     */
    async loadVoteList ({commit, dispatch}, payload: {contentType: string, contentId: number}) {
        if (!payload.contentId) {
            return
        }

        // Limpia la lista actual antes de solicita la nueva lista
        commit(MutationTypes.SetCurrentModerationVoteList, [])

        await dispatch('loadPermissionStatus')
        commit(
            MutationTypes.SetCurrentModerationVoteList,
            await api.getVotes(payload.contentType, payload.contentId),
        )
    },

    /**
     * Guarda los cambios del voto actualmente en edición por el usuario, si es nuevo,
     * se registrará en el servidor y si ya existe se actualizará su información
     */
    async saveVote ({state, commit}) {
        const vote = state.currentVote
        const result = vote.isNew
            ? await api.createVote(vote)
            : await api.updateVote(vote)

        commit(MutationTypes.SetCurrentModerationVote, result.vote)
        switch (vote.contentType) {
            // El tipo de contenido es una página estática, se actualiza el campo "approved"
            // de la página actualmente en edición
            case 'cms.page':
                commit(
                    'cms/UPDATE_CURRENT_PAGE_FIELD',
                    { field: 'approved', value: result.contentIsApproved },
                    {root: true},
                )
                break;
            case 'blog.post':
                commit(
                    'blog/post/current/field/update',
                    { path: 'approved', value: result.contentIsApproved },
                    {root: true},
                )
                break;
        }

        commit(MutationTypes.AddVoteToList, result.vote)
    },

    /**
     * Crea un nuevo voto de moderación y lo insertar como voto actual en edición
     */
    async createNewVote ({commit, rootState}, payload: VoteDescriptor) {
        const vote = new ModerationVote()
        vote.setContent(payload.contentType, payload.contentId)

        commit(MutationTypes.SetCurrentModerationVote, vote)
    },

    /**
     * Carga el permisos de moderación para el usuario actual
     */
    async loadPermissionStatus ({commit, rootState, state}) {
        // El permisos ya se ha obtenido de la API
        if (state.permissionFetched) {
            return
        }

        commit(
            MutationTypes.ToggleCurrentUserCanModerate,
            await api.getModeratorPermissionStatus(rootState.auth.user.id),
        )

        commit(MutationTypes.TogglePermissionFetched, true)
    },
}

export default actions
